import {logger, Util} from 'yougile-util'

/**
 * Client dev utils.
 */

export class DevUtils {
  private static devTurnedOn = false
  static websocketsFailureModeTurnedOn = false

  private static realSetTimeout = window.setTimeout
  private static realSetInterval = window.setInterval

  static isDev(): boolean {
    return DevUtils.devTurnedOn
  }

  static enable(): void {
    DevUtils.devTurnedOn = true
    DevUtils.tweakConsole()
    DevUtils.tweakTimeouts()
    logger.warn('Running in DEV mode')
  }

  private static tweakTimeouts(): void {
    ;(window as any).setTimeout = (cb: () => void, delay: number): number => {
      const isLarger = Math.random() > 0.5
      const mul = 0.1 + Math.random() * (isLarger ? 5 : 0.9)
      const plus = 200 * Math.random()
      const randomizedDelay = Math.round(delay * mul + plus)
      return DevUtils.realSetTimeout(cb, randomizedDelay)
    }
    ;(window as any).setInterval = (cb: () => void, delay: number): number => {
      const isLarger = Math.random() > 0.5
      const mul = 0.1 + Math.random() * (isLarger ? 5 : 0.9)
      const plus = 200 * Math.random()
      const randomizedDelay = Math.round(delay * mul + plus)
      return DevUtils.realSetInterval(cb, randomizedDelay)
    }
  }

  private static tweakConsole(): void {
    const tweakConsole = (name: string) => {
      const old = (console as any)[name]
      ;(window as any).console[name] = (...args: any[]) => {
        if (
          args[0] &&
          args[0].indexOf('Failed to load http') > -1 &&
          args[0].indexOf('/user-data/') > -1 &&
          args[0].indexOf('Possible Unhandled Promise Rejection') > -1
        ) {
          return
        }
        old('js:' + name, ...args)
      }
    }
    tweakConsole('log')
    tweakConsole('warn')
    tweakConsole('error')
  }

  static delay<T>(max: number): (arg: T) => Promise<T> {
    if (!DevUtils.devTurnedOn) {
      return arg => Promise.resolve(arg)
    }
    return async (arg: T) => {
      const delay = Math.round(Math.random() * max)
      await Util.wait(delay)
      return arg
    }
  }

  static delayed(
    max: number,
    cb: (...args: any[]) => void
  ): (...args: any[]) => void {
    if (!DevUtils.devTurnedOn) {
      return cb
    }
    const delay = Math.round(Math.random() * max)
    return (...args: any[]) => DevUtils.realSetTimeout(() => cb(...args), delay)
  }
}
